var _path, _path2, _path3, _path4, _rect, _rect2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconRt01(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.35832 8.80817L4.69995 18.0415C4.68512 18.2544 4.71429 18.468 4.78541 18.6693C4.85652 18.8704 4.96821 19.0548 5.11352 19.2111C5.25884 19.3673 5.43468 19.4921 5.63018 19.5776C5.82569 19.6631 6.03672 19.7076 6.2501 19.7082C6.46419 19.7087 6.67607 19.6651 6.87256 19.5801C7.06905 19.4951 7.24591 19.3705 7.39212 19.2142C7.53833 19.0578 7.65075 18.8729 7.72237 18.6712C7.79399 18.4694 7.82321 18.2551 7.80833 18.0415L7.14162 8.80817C7.12483 8.59892 7.02969 8.4037 6.8752 8.26156C6.7207 8.11942 6.51822 8.04083 6.30828 8.04151H6.19165C5.98172 8.04083 5.77923 8.11942 5.62474 8.26156C5.47024 8.4037 5.37512 8.59892 5.35832 8.80817Z",
    fill: "#9CA3AF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.25 10.5333C8.32107 10.5333 10 8.48134 10 5.95003C10 3.41872 8.32107 1.3667 6.25 1.3667C4.17893 1.3667 2.5 3.41872 2.5 5.95003C2.5 8.48134 4.17893 10.5333 6.25 10.5333Z",
    fill: "#C7CED5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 19.6666V2.16659C12.5 1.94557 12.5877 1.73361 12.744 1.57733C12.9003 1.42105 13.1123 1.33325 13.3333 1.33325C13.5543 1.33325 13.7663 1.42105 13.9226 1.57733C14.0788 1.73361 14.1667 1.94557 14.1667 2.16659V19.6666H12.5Z",
    fill: "#C7CED5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.417 19.6666V2.16659C15.417 1.94557 15.5047 1.73361 15.661 1.57733C15.8173 1.42105 16.0293 1.33325 16.2503 1.33325C16.4713 1.33325 16.6833 1.42105 16.8396 1.57733C16.9958 1.73361 17.0837 1.94557 17.0837 2.16659V19.6666H15.417Z",
    fill: "#C7CED5"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 12.5,
    y: 18,
    width: 1.66667,
    height: 1.66667,
    fill: "#9CA3AF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 15.417,
    y: 18,
    width: 1.66667,
    height: 1.66667,
    fill: "#9CA3AF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRt01);
export default __webpack_public_path__ + "static/media/icon_RT01.f1505861c41d30a594e6b794d0d8457e.svg";
export { ForwardRef as ReactComponent };